import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"none\" id=\"arrow-left\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.4113 13.7885L7.3507 14.8493L2.5 9.99911L7.35067 5.14844L8.41133 6.2091L5.38408 9.23635H17.4969V10.7363H5.35876L8.4113 13.7885Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol